<template>
  <div class="tabs">
    <ul
      class="nav nav-bold nav-pills bg-white px-8 pt-4"
      role="tablist"
      ref="builder-tab"
    >
      <li class="nav-item" v-for="tab in allTabs" :key="tab.slug">
        <a
          class="nav-link"
          :class="{ active: value === tab.slug }"
          v-on:click="(e) => setActiveTab(e, tab.name)"
          :href="`#/settings/${tab.slug}`"
          :data-tab="tab.slug"
          data-toggle="tab"
          role="tab"
        >
          {{ tab.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: this.$router.currentRoute.name,
    };
  },
  methods: {
    genSlug(str) {
      return str
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    },
    setActiveTab(event, tabName) {
      this.value = this.genSlug(tabName);
      this.$emit("input", this.value);
    },
  },
  computed: {
    allTabs() {
      return this.tabs.map((tabName, idx) => ({
        name: tabName,
        slug: this.genSlug(tabName),
      }));
    },
  },
};
</script>

<style></style>
